import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=312d5e5e&scoped=true"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicy.vue?vue&type=style&index=0&id=312d5e5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../Development/graduation/graduate-frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312d5e5e",
  null
  
)

export default component.exports